import { cn } from '@/new/lib/utils';

export function Icon({ className }: { className: string }) {
  const isColorIcon = className.includes('iconify-color');
  return <span className={cn(!isColorIcon && 'iconify', 'flex shrink-0 items-center', className)} />;
}
